import { fetchToken } from "../../../common/FetchCookie";
import { SUBSCRIPTIONS } from "../../../common/URLs";


export const fetchSubscription = async () => {
  try {
    const token = await fetchToken()

    const response = await fetch(SUBSCRIPTIONS, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.response?.msg || `HTTP error! Status: ${response.status}`
      );
    }
    const data = await response.json();
    return data.response || [];
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const addSubscription = async (newSubscription) => {
  try {
    const token = await fetchToken()

    const response = await fetch(SUBSCRIPTIONS, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newSubscription),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.response?.msg ||
        `Error adding subscription: ${response.statusText}`
      );
    }

    const data = await response.json();
    return data.response || data;
  } catch (error) {
    console.error("Add error:", error);
    throw error;
  }
};

export const updateSubscription = async (id, updateSubscriptiondata) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${SUBSCRIPTIONS}/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updateSubscriptiondata),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.response?.msg || `Error updating: ${response.statusText}`
      );
    }

    const data = await response.json();
    return data.response || data;
  } catch (error) {
    console.error("Update error:", error);
    throw error;
  }
};

export const deleteSubscription = async (id) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${SUBSCRIPTIONS}/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.response?.msg || `Error deleting: ${response.statusText}`
      );
    }

    return { success: true, id };
  } catch (error) {
    console.error("Delete error:", error);
    throw error;
  }
};

export const fetchEmployerSubscription = async (page = 1) => {
  const url = `https://api.indiahirings.com/admin/subscriptions-details-employer?page=${page}`;
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return {
      data: data.response.data || [],
      pagination: {
        current_page: data.response.current_page,
        last_page: data.response.last_page,
        total: data.response.total,
      },
    };
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};
export const fetchCandidateSubscription = async (page = 1) => {
  const url = `https://api.indiahirings.com/admin/subscriptions-details-candidate?page=${page}`;
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return {
      data: data.response.data || [],
      pagination: {
        current_page: data.response.current_page,
        last_page: data.response.last_page,
        total: data.response.total,
      },
    };
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};
